module.exports = __webpack_public_path__ + "assets/media/hisamudinova_u.8023f598.jpg";